import { computed, observable } from 'mobx'

import ModelStore from '../../../../shared-lib/stores/ModelStore'
import moment from 'moment'
import { $RootStore } from '../../../../src/stores/RootStore'

export default class CrmInvoiceModel extends ModelStore {
  @observable accessor data: CrmInvoice = {
    _id: '',
    professionalId: '',
    usageLines: [],
    paid: false,
    totalAmount: 0,
    unpaidAmount: 0,
    endDate: new Date(),
    startDate: new Date(),
  }

  constructor(data: Partial<CrmInvoice>, rootStore: $RootStore) {
    super(data, rootStore)
    this.merge(data)
  }

  @computed get dateTitle() {
    if (moment(this.data.endDate).isAfter(moment())) {
      return 'This week'
    }

    return `${moment(this.data.startDate).format("Do MMM [']YY")} - ${moment(this.data.endDate).format("Do MMM [']YY")}`
  }
}
